import React from "react";

import { sortBy } from "lodash";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import Table from "components/Table";

import { ReportType, REPORT_DISPLAY_NAME } from "constants/reports";

import { filterAll } from "lib";

import { getFavouritesReportsListByTab } from "selectors";

import { agentReport } from "./columns";

const ReportTitle = styled.h3`
  margin-left: ${({ theme }) => theme.space[1]}px;
`;
const {
  columnsGeneralFavourites,
  columnsAgenciesFavourites,
  columnsBuyersFavourites,
  columnsVendorsFavourites,
} = agentReport;

const columns = {
  [ReportType.AGENCIES]: columnsAgenciesFavourites,
  [ReportType.AGENTS]: columnsAgenciesFavourites,
  [ReportType.BRANCHES]: columnsGeneralFavourites,
  [ReportType.BUYERS]: columnsBuyersFavourites,
  [ReportType.CARDS]: columnsAgenciesFavourites,
  [ReportType.VENDORS]: columnsVendorsFavourites,
  [ReportType.SALEYARD]: columnsGeneralFavourites,
  [ReportType.SALE_FILES]: columnsGeneralFavourites,
  [ReportType.SALE_EXPORT]: columnsGeneralFavourites,
  [ReportType.NLIS]: columnsGeneralFavourites,
  [ReportType.STUD]: columnsGeneralFavourites,
};

export const FavouritesTables = ({ searchTerm }) => {
  const favouritesReportList = useSelector(getFavouritesReportsListByTab);
  const filteredReports = React.useMemo(
    () =>
      Object.entries(favouritesReportList).reduce((acc, [tab, reportsList]) => {
        acc[tab] = filterAll(reportsList, searchTerm);
        return acc;
      }, {}),
    [searchTerm, favouritesReportList],
  );
  return (
    <>
      {sortBy(
        Object.keys(filteredReports),
        tabKey => REPORT_DISPLAY_NAME[tabKey],
      ).map((tabKey, idx) => {
        const reportsList = filteredReports[tabKey];
        return (
          reportsList.length > 0 && (
            <div key={idx}>
              <ReportTitle>{REPORT_DISPLAY_NAME[tabKey]} Reports</ReportTitle>
              <Table
                data={reportsList}
                columns={columns[tabKey]}
                suppressNoResult
              />
            </div>
          )
        );
      })}
    </>
  );
};
